import { FilterToolbarShell } from "@packages/core-client/collection/FilterToolbarShell.tsx";
import { RevieweeFilterBar } from "../../reviewee-filters/RevieweeFilterBar.tsx";

export function CycleFilterBar() {
    return (
        <FilterToolbarShell>
            <div className="px-4 py-3">
                <RevieweeFilterBar />
            </div>
        </FilterToolbarShell>
    );
}
